<template>
  <div class="px-4 bg-cool-gray-200 min-h-screen-mobile-safe py-10">
    <!-- We've used 3xl here, but feel free to try other max-widths based on your needs -->
    <div class="max-w-xl mx-auto">
      <img src="/images/Cardstock_Logo.png" class="block mx-auto my-4 lg:mb-8 mb-4 max-w-32 sm:max-w-64">
      <div class="bg-white overflow-hidden shadow border border-cool-gray-200 rounded-lg">
        <div class="bg-white px-4 py-5 border-b border-gray-200 sm:px-6">
          <div class="-ml-4 -mt-4 flex justify-between items-center flex-wrap sm:flex-nowrap">
            <div class="ml-4 mt-4">
              <div class="flex items-center">
                <div class="">
                  <h3 class="text-lg leading-6 font-medium text-gray-900">
                    {{currentUser.first}} {{currentUser.last}}
                  </h3>
                  <p class="text-sm leading-5 text-gray-500">
                    {{currentUser.email}}
                  </p>
                </div>
              </div>
            </div>
            <div class="ml-4 mt-4 flex-shrink-0 flex">
              <span class="ml-3 inline-flex rounded-md shadow-sm">
                <router-link
                  class="relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm leading-5 font-medium rounded-md text-gray-700 bg-white hover:text-gray-500 focus:outline-none focus:ring-blue focus:border-blue-300 active:bg-gray-50 active:text-gray-800"
                  :to="{name: 'logout'}"
                >
                  <span>
                    Logout
                  </span>
                </router-link>
              </span>
            </div>
          </div>
        </div>

          <ul>
            <li>
              <router-link
                v-for="teacher in teachers"
                :to="{name: 'conversations', params: {teamId: teacher.team.id}}"
                class="block hover:bg-gray-50 focus:outline-none focus:bg-gray-50 transition duration-150 ease-in-out"
                :key="teacher.id"
              >
                <div class="px-4 py-4 flex items-center sm:px-6">
                  <div class="min-w-0 flex-1 sm:flex sm:items-center sm:justify-between">
                    <div>
                      <div class="text-md leading-5 font-medium text-indigo-600 truncate">
                        {{teacher.team.name}}
                      </div>
                      <div class="mt-2 flex">
                        <div class="flex items-center text-sm leading-5 text-gray-500">
                          <span>
                            Joined <TimeAgo :time="teacher.insertedAt" />
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="ml-5 flex-shrink-0">
                    <svg class="h-5 w-5 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
                      <path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd"/>
                    </svg>
                  </div>
                </div>
              </router-link>
            </li>
          </ul>

      </div>
    </div>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import _get from 'lodash/get'

import { tz } from '@/tz'
import apolloProvider from '@/apolloProvider'
import {responseHandler, errorHandler} from '@/responseHandler'
import { preload }  from '@/preloader'

import Container from '@/components/Container.vue'
import Navigation from '@/components/Navigation.vue'
import Panel from '@/components/Panel.vue'
import Viewport from '@/components/Viewport.vue'
import TimeAgo from '@/components/TimeAgo.vue'

import CurrentUserQuery from '@/queries/CurrentUserWithTeachers.gql'

export default {
  components: {
    Container,
    Navigation,
    TimeAgo
  },

  props: ['currentUser'],

  beforeRouteEnter: (to, from, next) => {
    preload({
      queryName: 'currentUser',
      query: CurrentUserQuery,
      variables: { tz: tz() },
      fetchPolicy: 'network-only',
      onSuccess: ({data}) => {
        next( vm => {
          vm.$apollo.addSmartQuery('currentUser', {
            fetchPolicy: 'cache-only',
            query: CurrentUserQuery,
            variables: { tz: tz() }
          })
        })
      },
      callback: next
    })
  },

  computed: {
    teachers() {
      return _get(this, 'currentUser.teachers')
    }
  }
}
</script>
